export interface LocalDepartments {
  county: {
    total: number;
    name: string;
    slug: string;
  };
  nafLocations: {
    title: string;
    ingress: string;
    clubNumber: string;
    link: {
      type: string;
      data: {
        slug: string;
        type: string;
      };
    };
    coordinates: {
      latitude: number;
      longitude: number;
    };
    distanceInMeters?: number;
  }[];
}

export interface LocalDepartmentItem {
  title: string;
  ingress: string;
  clubNumber: string;
  link: {
    type: string;
    data: {
      slug: string;
      type: string;
      parent?: string | null;
    };
  };
  coordinates: {
    latitude: number | null;
    longitude: number | null;
  } | null;
}

export enum LocationSlugs {
  lokalavdeling = 'local-departments',
  mc = 'mc-clubs',
  nafCenters = 'naf-centers',
  practiceTracks = 'practice-tracks',
}
